export const ROLES_META = {
  navigationLabel: "Roles",
  sectionLabel: "Role Master",
  pageTitle: "Roles & Access Control",
} as const;
